<template>
  <div>
    <json-editor
      :content="json.content"
      :id="json.id"
      :name="json.name"
      :description="json.description"
      @rollback="rollback"
      @save="saveJson"
      @edit-description="editJsonDescription"
      @import="importJson"
      @export="exportJson"
    ></json-editor>
    <option-dialog
      title="请输入描述"
      :visible="visibleEditDescription"
      @close="handleClose('editDescription')"
      @submit="handleSubmit('editDescription')"
    >
      <div>
        <el-input v-model="description"></el-input>
      </div>
    </option-dialog>
    <option-dialog
      title="请输入文件url地址"
      :visible="visibleImport"
      @close="handleClose('import')"
      @submit="handleSubmit('import')"
    >
      <div class="option-dialog-body">
        <div class="tips">
          <i class="el-icon-warning"></i>导入内容将覆盖当前编辑内容
        </div>
        <el-input v-model="fileUrl"></el-input>
      </div>
    </option-dialog>
    <option-dialog
      title="请输入导出文件名"
      :visible="visibleExport"
      @close="handleClose('export')"
      @submit="handleSubmit('export')"
    >
      <div>
        <el-input v-model="exportFileName"></el-input>
      </div>
    </option-dialog>
  </div>
</template>

<script>
import JsonEditor from "@/components/json-editor";
import OptionDialog from "./option-dialog.vue";
export default {
  name: "EditJson",
  data() {
    return {
      json: {
        id: "",
        name: "",
        content: {},
        description: ""
      },
      fileUrl: "",
      exportFileName: "",
      description: "",
      isCreate: false,
      visibleEditDescription: false,
      visibleImport: false,
      visibleExport: false
    };
  },
  components: {
    JsonEditor,
    OptionDialog
  },
  mounted() {
    const { id } = this.$route.params;
    if (id) {
      this.fetchJson(id);
    } else {
      this.isCreate = true;
    }
  },
  methods: {
    saveJson(content) {
      if (this.isCreate || !this.json.id) {
        let json = {
          content: JSON.stringify(content)
        };
        if (this.json.name) {
          json.name = this.json.name;
        }
        this.postJson(json);
      } else {
        this.updateJson({
          content: JSON.stringify(content)
        })
          .then(res => {
            this.$message({
              type: "success",
              message: "保存成功！"
            });
            setTimeout(() => {
              this.rollback();
            }, 1000);
          })
          .catch(e => {
            this.$message({
              type: "error",
              message: e
            });
          });
      }
    },
    rollback() {
      this.$router.push("/json/list");
    },
    handleClose(type) {
      const captype = type[0].toUpperCase() + type.slice(1);
      this[`visible${captype}`] = false;
    },
    handleSubmit(type) {
      const captype = type[0].toUpperCase() + type.slice(1);
      if (type === "export") {
        this.exportFile(this.exportFileName, JSON.stringify(this.json.content));
        this.visibleExport = false;
        this.exportFileName = "";
      } else if (type === "import") {
        this.submitImport();
      } else if (type === "editDescription") {
        this.submitEditDescription();
      } else {
        this[`visible${captype}`] = false;
      }
    },

    editJsonDescription() {
      this.description = this.json.description;
      this.visibleEditDescription = true;
    },
    exportFile(name, content) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.download = `${name}.json`;
      const blob = new Blob([content]);
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    importJson() {
      this.visibleImport = true;
    },
    exportJson(content) {
      this.exportFileName = this.json.name;
      this.json.content = content;
      this.visibleExport = true;
    },

    submitImport() {
      lib.tmsapi.post({
        api: "api/test/json/fetch",
        data: {
          fileUrl: this.fileUrl
        },
        success: res => {
          this.json.content = res.data;
          this.handleClose("import");
        },
        error: e => {
          console.error(e);
        }
      });
    },
    submitEditDescription() {
      if (this.isCreate || !this.json.id) {
        this.postJson({
          name: this.description,
          content: JSON.stringify(this.json.content)
        });
      } else {
        this.updateJson({ description: this.description })
          .then(() => {
            this.json.description = this.description;
            this.visibleEditDescription = false;
            this.description = "";
            this.$message({
              type: "success",
              message: "描述更新成功！"
            });
          })
          .catch(e => {
            this.$message({
              type: "error",
              message: e
            });
          });
      }
    },
    postJson(data) {
      lib.tmsapi.post({
        api: "api/test/json",
        data,
        success: res => {
          this.json.id = res.data.id;
          this.json.name = res.data.name;
          this.json.content = JSON.parse(res.data.content);
          this.$message({
            type: "success",
            message: "保存成功！"
          });
          setTimeout(() => {
            this.rollback();
          }, 1000);
          this.isCreate = false;
          this.visibleRename = false;
        },
        error: e => {
          console.log(e, "e");
          this.$message({
            type: "error",
            message: e.message
          });
        }
      });
    },
    fetchJson(id) {
      lib.tmsapi.get({
        api: `api/test/json/${id}`,
        success: res => {
          this.json.name = res.data.name;
          this.json.description = res.data.description;
          this.json.id = res.data._id;
          this.json.content = JSON.parse(res.data.content);
        }
      });
    },
    updateJson(data) {
      return new Promise((resolve, reject) => {
        lib.tmsapi.post({
          api: `api/test/json/${this.json.id}`,
          data,
          success: res => {
            resolve(res.data);
          },
          error: err => {
            reject(err.message);
          }
        });
      });
    }
  }
};
</script>
<style>
.container-fluid {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  .option-dialog-body {
    .tips {
      color: #e6a23c;
      margin-bottom: 20px;
      i.el-icon-warning {
        font-size: 18px;
        padding-right: 4px;
      }
    }
  }
}
</style>
